import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconLocationPin: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
        xmlns: 'http://www.w3.org/2000/svg',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4 10C4 4.1 8.8 2 12 2C15.2 2 20 4.1 20 10C20 16.4 12.9 21.6 12.6 21.8C12.4 21.9 12.2 22 12 22C11.8 22 11.6 21.9 11.4 21.8C11.1 21.6 4 16.4 4 10ZM6 10C6 14.4 10.4 18.4 12 19.7C13.6 18.4 18 14.4 18 10C18 5.3 14.1 4 12 4C9.9 4 6 5.3 6 10ZM8 10C8 7.8 9.8 6 12 6C14.2 6 16 7.8 16 10C16 12.2 14.2 14 12 14C9.8 14 8 12.2 8 10ZM10 10C10 11.1 10.9 12 12 12C13.1 12 14 11.1 14 10C14 8.9 13.1 8 12 8C10.9 8 10 8.9 10 10Z',
    })
  )
}
